import React from 'react';
import { AdminReviewIcon, ChangePasswordIcon, DashboardIcon, DocumentVerifyIcon, HomePageSettingIcon, ListingRequestIcon, ListSettingIcon, ManageAdminIcon, ManageCancellationIcon, ManageCurrencyIcon, ManageInquiryIcon, ManageListingIcon, ManagePaymentIcon, ManagePayoutIcon, ManageReportIcon, ManageReservationIcon, ManageReviewIcon, ManageServiceFeeIcon, ManageSiteIcon, ManageUserIcon, MessagesIcon, PrimaryContentIcon, SafetyLandingIcon, SearchSettingIcon, SideMenuSubArrow, SiteSettingIcon, SmtpIcon, StaticContentIcon, WhyBecomeHostIcon, WhyHostIcon } from '../components/Common/Assets/SvgComponent/SiteAdminSvgIcon';

const getDashboardSideMenu = [
    {
        label: "dashboard",
        activePaths: ["/siteadmin/dashboard"],
        href: "/siteadmin",
        icon: <DashboardIcon />,
        isValidatePrivilege: false
    }
];

const getConfigurationSideMenu = [
    {
        label: "siteSettings",
        activePaths: ["/siteadmin/settings/site"],
        href: "/siteadmin/settings/site",
        icon: <SiteSettingIcon />,
        isValidatePrivilege: true,
        privilegeId: 1
    },
    {
        label: "manageSiteConfig",
        activePaths: ["/siteadmin/settings/config"],
        href: "/siteadmin/settings/config",
        icon: <ManageSiteIcon />,
        isValidatePrivilege: true,
        privilegeId: 20
    },
    {
        label: "smtpSetupLabel",
        activePaths: ["/siteadmin/smtp-info"],
        href: "/siteadmin/smtp-info",
        icon: <SmtpIcon />,
        isValidatePrivilege: true,
        privilegeId: 25
    },
    {
        label: "manageCurrency",
        activePaths: ["/siteadmin/currency"],
        href: "/siteadmin/currency",
        icon: <ManageCurrencyIcon />,
        isSuperAdmin: true,
        isValidatePrivilege: true
    },
    {
        label: "searchSettings",
        activePaths: ["/siteadmin/settings/search"],
        href: "/siteadmin/settings/search",
        icon: <SearchSettingIcon />,
        isValidatePrivilege: true,
        privilegeId: 11
    },
    {
        label: "managePaymentGateWay",
        activePaths: ["/siteadmin/payment-gateway-section"],
        href: "/siteadmin/payment-gateway-section",
        icon: <ManagePaymentIcon />,
        isValidatePrivilege: true,
        privilegeId: 24
    },
    {
        label: "homePageSettings",
        paths: ['/siteadmin/home/caption', '/siteadmin/home/banner', '/siteadmin/popularlocation',
            '/siteadmin/home/static-info-block', '/siteadmin/home/home-banner', '/siteadmin/home/footer-block',
            '/siteadmin/popularlocation/add', '/siteadmin/edit/popularlocation/'],
        isAccordion: true,
        icon: <HomePageSettingIcon />,
        isValidatePrivilege: true,
        privilegeId: 12,
        matchType: 'regex',
        data: [
            {
                label: "bannerCaptionLabel",
                activePaths: ["/siteadmin/home/caption"],
                href: "/siteadmin/home/caption",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 12
            },
            {
                label: "homePageBanner",
                activePaths: ["/siteadmin/home/home-banner"],
                href: "/siteadmin/home/home-banner",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 12
            },
            {
                label: "managePopularLocations",
                activePaths: ["/siteadmin/popularlocation", "/siteadmin/edit/popularlocation/", "/siteadmin/popularlocation/add"],
                href: "/siteadmin/popularlocation",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 12,
                matchType: 'regex'
            },
            {
                label: "imageBannerLabel",
                activePaths: ["/siteadmin/home/banner"],
                href: "/siteadmin/home/banner",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 12
            },
            {
                label: "staticInfoBlock",
                activePaths: ["/siteadmin/home/static-info-block"],
                href: "/siteadmin/home/static-info-block",
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 12
            },
            {
                label: "footerBlockLabel",
                activePaths: ['/siteadmin/home/footer-block'],
                href: '/siteadmin/home/footer-block',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 12
            }
        ]
    },
    {
        label: "whyHostPage",
        activePaths: ["/siteadmin/why-host"],
        href: "/siteadmin/why-host",
        icon: <WhyHostIcon />,
        isValidatePrivilege: true,
        privilegeId: 22
    },
    {
        label: "whyBecomeHostPage",
        paths: ['/siteadmin/whyHost/Block1', '/siteadmin/whyHost/Block2', '/siteadmin/whyHost/Block3', '/siteadmin/whyHost/Block4',
            '/siteadmin/whyHost/Block6', '/siteadmin/whyHost/review', '/siteadmin/whyHost/Block7', '/siteadmin/whyHost/review/add/',
            '/siteadmin/whyHost/review/edit/'
        ],
        isAccordion: true,
        icon: <WhyBecomeHostIcon />,
        isValidatePrivilege: true,
        privilegeId: 16,
        matchType: 'regex',
        data: [
            {
                label: "blockLabel1",
                activePaths: ['/siteadmin/whyHost/Block1'],
                href: '/siteadmin/whyHost/Block1',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 16
            },
            {
                label: "blockLabel2",
                activePaths: ['/siteadmin/whyHost/Block2'],
                href: '/siteadmin/whyHost/Block2',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 16
            },
            {
                label: "blockLabel3",
                activePaths: ['/siteadmin/whyHost/Block3'],
                href: '/siteadmin/whyHost/Block3',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 16
            },
            {
                label: "blockLabel4",
                activePaths: ['/siteadmin/whyHost/Block4'],
                href: '/siteadmin/whyHost/Block4',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 16
            },
            {
                label: "blockLabel5",
                activePaths: ['/siteadmin/whyHost/review', '/siteadmin/whyHost/review/add/', '/siteadmin/whyHost/review/edit/'],
                href: '/siteadmin/whyHost/review',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 16,
                matchType: 'regex'
            },
            {
                label: "blockLabel6",
                activePaths: ['/siteadmin/whyHost/Block6'],
                href: '/siteadmin/whyHost/Block6',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 16
            },
            {
                label: "blockLabel7",
                activePaths: ['/siteadmin/whyHost/Block7'],
                href: '/siteadmin/whyHost/Block7',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 16
            }
        ]
    },
];

const getAdminConfigSideMenu = [
    {
        label: "manageAdmin",
        paths: ['/siteadmin/admin-users', '/siteadmin/admin-roles'],
        isAccordion: true,
        icon: <ManageAdminIcon />,
        isValidatePrivilege: true,
        isSuperAdmin: true,
        data: [
            {
                label: "manageAdminUsers",
                activePaths: ['/siteadmin/admin-users'],
                href: '/siteadmin/admin-users',
                icon: <SideMenuSubArrow />,
            },
            {
                label: "manageAdminRoles",
                activePaths: ['/siteadmin/admin-roles'],
                href: '/siteadmin/admin-roles',
                icon: <SideMenuSubArrow />,
            },
        ]
    },
    {
        label: "changePasswordLabel",
        activePaths: ["/siteadmin/change/admin"],
        href: "/siteadmin/change/admin",
        icon: <ChangePasswordIcon />,
        isValidatePrivilege: false
    },
];

const getUsersSideMenu = [
    {
        label: "manageUser",
        activePaths: ["/siteadmin/users", "/siteadmin/edit-profile/", "/siteadmin/profile-view/"],
        href: "/siteadmin/users",
        icon: <ManageUserIcon />,
        isValidatePrivilege: true,
        privilegeId: 2
    },
    {
        label: "documentverificaiton",
        activePaths: ["/siteadmin/document"],
        href: "/siteadmin/document",
        icon: <DocumentVerifyIcon />,
        isValidatePrivilege: true,
        privilegeId: 8
    },
    {
        label: "reportManagement",
        activePaths: ["/siteadmin/reportUser"],
        href: "/siteadmin/reportUser",
        icon: <ManageReportIcon />,
        isValidatePrivilege: true,
        privilegeId: 10
    }
];

const getListSettingsMenu = [
    {
        label: "listSettingsForStep1",
        paths: ['/siteadmin/listsettings/1', '/siteadmin/listsettings/2', '/siteadmin/listsettings/3',
            '/siteadmin/listsettings/4', '/siteadmin/listsettings/5', '/siteadmin/listsettings/6',
            '/siteadmin/listsettings/7', '/siteadmin/listsettings/8', '/siteadmin/listsettings/9',
            '/siteadmin/listsettings/10', '/siteadmin/listsettings/11', '/siteadmin/listsettings/12'
        ],
        isAccordion: true,
        icon: <ListSettingIcon />,
        isValidatePrivilege: true,
        privilegeId: 14,
        data: [
            {
                label: "roomType",
                activePaths: ['/siteadmin/listsettings/1'],
                href: '/siteadmin/listsettings/1',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 14
            },
            {
                label: "personCapacity",
                activePaths: ['/siteadmin/listsettings/2'],
                href: '/siteadmin/listsettings/2',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 14
            },
            {
                label: "houseTypeLabel",
                activePaths: ['/siteadmin/listsettings/3'],
                href: '/siteadmin/listsettings/3',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 14
            },
            {
                label: "buildingSize",
                activePaths: ['/siteadmin/listsettings/4'],
                href: '/siteadmin/listsettings/4',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 14
            },
            {
                label: "bedRoomsLabel",
                activePaths: ['/siteadmin/listsettings/5'],
                href: '/siteadmin/listsettings/5',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 14
            },
            {
                label: "bedsCapital",
                activePaths: ['/siteadmin/listsettings/6'],
                href: '/siteadmin/listsettings/6',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 14
            },
            {
                label: "bedTypeLabel",
                activePaths: ['/siteadmin/listsettings/7'],
                href: '/siteadmin/listsettings/7',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 14
            },
            {
                label: "bathrooms",
                activePaths: ['/siteadmin/listsettings/8'],
                href: '/siteadmin/listsettings/8',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 14
            },
            {
                label: "bathroomType",
                activePaths: ['/siteadmin/listsettings/9'],
                href: '/siteadmin/listsettings/9',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 14
            },
            {
                label: "essentialAmenities",
                activePaths: ['/siteadmin/listsettings/10'],
                href: '/siteadmin/listsettings/10',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 14
            },
            {
                label: "safetyFeatures",
                activePaths: ['/siteadmin/listsettings/11'],
                href: '/siteadmin/listsettings/11',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 14
            },
            {
                label: "myHostSpaces",
                activePaths: ['/siteadmin/listsettings/12'],
                href: '/siteadmin/listsettings/12',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 14
            }
        ]
    },
    {
        label: "listSettingsForStep3",
        paths: ['/siteadmin/listsettings/13', '/siteadmin/listsettings/14',
            '/siteadmin/listsettings/18', '/siteadmin/listsettings/19'
        ],
        isAccordion: true,
        icon: <ListSettingIcon />,
        isValidatePrivilege: true,
        privilegeId: 14,
        data: [
            {
                label: "guestRequirements",
                activePaths: ['/siteadmin/listsettings/13'],
                href: '/siteadmin/listsettings/13',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 14
            },
            {
                label: "houseRules",
                activePaths: ['/siteadmin/listsettings/14'],
                href: '/siteadmin/listsettings/14',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 14
            },
            {
                label: "minimumNightsLabel",
                activePaths: ['/siteadmin/listsettings/18'],
                href: '/siteadmin/listsettings/18',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 14
            },
            {
                label: "maximumNightsLabel",
                activePaths: ['/siteadmin/listsettings/19'],
                href: '/siteadmin/listsettings/19',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 14
            },
        ]
    },
];

const getListingMenu = [
    {
        label: "listingsManagement",
        activePaths: ['/siteadmin/listings'],
        href: '/siteadmin/listings',
        icon: <ManageListingIcon />,
        isValidatePrivilege: true,
        privilegeId: 3
    },
    {
        label: "listingApproval",
        activePaths: ['/siteadmin/listing-request'],
        href: '/siteadmin/listing-request',
        icon: <ListingRequestIcon />,
        isValidatePrivilege: true,
        privilegeId: 3
    }
];

const getReservationMenu = [
    {
        label: "manageServiceFee",
        activePaths: ['/siteadmin/settings/servicefees'],
        href: '/siteadmin/settings/servicefees',
        icon: <ManageServiceFeeIcon />,
        isValidatePrivilege: true,
        privilegeId: 7
    },
    {
        label: "cancellationPolicyManagement",
        activePaths: ['/siteadmin/cancellation-policies/management', '/siteadmin/cancellation-policies/edit/'],
        href: '/siteadmin/cancellation-policies/management',
        icon: <ManageCancellationIcon />,
        isValidatePrivilege: true,
        privilegeId: 21
    },
    {
        label: "manageReservations",
        activePaths: ['/siteadmin/reservations', '/siteadmin/viewreservation/'],
        href: '/siteadmin/reservations',
        icon: <ManageReservationIcon />,
        isValidatePrivilege: true,
        privilegeId: 4
    },
    {
        label: "manageInquiry",
        activePaths: ['/siteadmin/inquiry', '/siteadmin/viewInquiry'],
        href: '/siteadmin/inquiry',
        icon: <ManageInquiryIcon />,
        isValidatePrivilege: true,
        privilegeId: 23
    },
    {
        label: "messages",
        activePaths: ['/siteadmin/messages'],
        href: '/siteadmin/messages',
        icon: <MessagesIcon />,
        isValidatePrivilege: true,
        privilegeId: 9
    },
    {
        label: "manageTransactions",
        paths: ['/siteadmin/payout', '/siteadmin/viewpayout/', '/siteadmin/refund', '/siteadmin/viewrefund/', '/siteadmin/payoutQR', '/siteadmin/viewPayoutQR/'],
        isAccordion: true,
        icon: <ManagePayoutIcon />,
        isValidatePrivilege: true,
        matchType: 'regex',
        privilegeId: 17,
        data: [
            {
                label: "managePayout",
                activePaths: ['/siteadmin/payout', '/siteadmin/viewpayout/'],
                href: '/siteadmin/payout',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                matchType: 'regex'
            },
            {
                label: "manageRefund",
                activePaths: ['/siteadmin/refund', '/siteadmin/viewrefund/'],
                href: '/siteadmin/refund',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                matchType: 'regex'
            },
            {
                label: "manageQRPayout",
                activePaths: ['/siteadmin/payoutQR', '/siteadmin/viewPayoutQR/'],
                href: '/siteadmin/payoutQR',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                matchType: 'regex'
            },
        ]
    },
    {
        label: "manageReviwes",
        activePaths: ['/siteadmin/user-reviews', '/siteadmin/management-reviews/'],
        href: '/siteadmin/user-reviews',
        icon: <ManageReviewIcon />,
        isValidatePrivilege: true,
        privilegeId: 5,
        matchType: 'regex'
    },
    {
        label: "adminReviews",
        paths: ['/siteadmin/reviews', '/siteadmin/reviews/edit-review', '/siteadmin/write-reviews'],
        isAccordion: true,
        icon: <AdminReviewIcon />,
        isValidatePrivilege: true,
        privilegeId: 6,
        matchType: 'regex',
        data: [
            {
                label: "manageAdminReviews",
                activePaths: ['/siteadmin/reviews', '/siteadmin/reviews/edit-review'],
                href: '/siteadmin/reviews',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 6,
                matchType: 'regex'
            },
            {
                label: "writeReviwes",
                activePaths: ['/siteadmin/write-reviews'],
                href: '/siteadmin/write-reviews',
                icon: <SideMenuSubArrow />,
                isValidatePrivilege: true,
                privilegeId: 6,
            },
        ]
    },
];

const getContentPageMenu = [
    {
        label: "contentManagementLabel",
        activePaths: ['/siteadmin/content-management', '/siteadmin/edit/page', '/siteadmin/page/add'],
        href: '/siteadmin/content-management',
        icon: <PrimaryContentIcon />,
        isValidatePrivilege: true,
        privilegeId: 18
    },
    {
        label: "staticContentManagement",
        activePaths: ['/siteadmin/staticpage/management', '/siteadmin/edit/staticpage/'],
        href: '/siteadmin/staticpage/management',
        icon: <StaticContentIcon />,
        isValidatePrivilege: true,
        privilegeId: 18
    },
    {
        label: "safetyLanding",
        activePaths: ['/siteadmin/safety'],
        href: '/siteadmin/safety',
        icon: <SafetyLandingIcon />,
        isValidatePrivilege: true,
        privilegeId: 15
    }
];

export {
    getDashboardSideMenu,
    getConfigurationSideMenu,
    getAdminConfigSideMenu,
    getUsersSideMenu,
    getListSettingsMenu,
    getListingMenu,
    getReservationMenu,
    getContentPageMenu
}